// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcbfcfec","455":"f288e8ae","977":"45dc18e1"}[chunkId] + ".chunk.js";
};